import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    CardFooter,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    ListGroup,
    ListGroupItem
} from 'reactstrap';
import { MostrarSolicitudes } from '../../ServicesCMSManager.js';//APIS

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../store/actions/actions';
import swal from 'sweetalert';
import TooltipItem from '../Common/TooltipItem.js';
import ToggleFullscreen from '../Common/ToggleFullscreen';
//scroll
import Scrollable from '../Common/Scrollable'

import HeaderRun from './Header.run'

class Header extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            iNumeroIncidencias: 0,
            aResultadoMostrarSolicitudes: {
                iEstatus: null,
                sMensaje: null,
                aResult: []
            }
        }
    }


    componentDidMount() {
        HeaderRun();
        this.ConsultarIncidencias();
        //setInterval(() => {}, 1000);
    }

    ConsultarIncidencias() {
      //MostrarSolicitudes = (IDEmpresa)
      MostrarSolicitudes(sessionStorage.getItem('iIDEmpresa')).then((res) => {
        this.setState({
          aResultadoMostrarSolicitudes: {
            iEstatus: res.estatus,
            sMensaje: res.mensaje,
            aResult: res.Result
          }
        });
        if (res.estatus == 1) {
          this.setState({iNumeroIncidencias: res.Result.length});
          sessionStorage.setItem('iNumeroIncidencias', res.Result.length);
        }
      })
    }

    toggleUserblock = e => {
        e.preventDefault();
        this.props.actions.toggleSetting('showUserBlock');
    }

    toggleOffsidebar = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('offsidebarOpen');
    }

    toggleCollapsed = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('isCollapsed');
        this.resize()
    }

    toggleAside = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('asideToggled');
    }

    resize() {
        // all IE friendly dispatchEvent
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
        // modern dispatchEvent way
        // window.dispatchEvent(new Event('resize'));
    }

    render() {
        return (
            <header className="topnavbar-wrapper">
                { /* START Top Navbar */}
                <nav className="navbar topnavbar">
                    { /* START navbar header */}
                    <div className="navbar-header">
                        <a className="navbar-brand" href="/inicio">
                            <div className="brand-logo text-white">
                                <img className="img-fluid" src="img/Logo-cms-blanco.png" alt="App Logo"
                                     style={{width: 'auto', height: '40px'}}/>
                            </div>
                            <div className="brand-logo-collapsed">
                                <img className="img-fluid" src="img/Logo-N35.png" alt="App Logo"/>
                            </div>
                        </a>
                    </div>
                    { /* END navbar header */}

                    { /* START Left navbar */}
                    <ul className="navbar-nav mr-auto flex-row">
                        <li className="nav-item">
                            { /* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
                            <TooltipItem placement="right" content={<span>Menú</span>}>
                                <a href="" className="nav-link d-none d-md-block d-lg-block d-xl-block"
                                onClick={this.toggleCollapsed}>
                                    <em className="fas fa-bars"></em>
                                </a>
                            </TooltipItem>
                            { /* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
                            <a href="" className="nav-link sidebar-toggle d-md-none" onClick={this.toggleAside}>
                                <em className="fas fa-bars"></em>
                            </a>
                        </li>
                        { /* START User avatar toggle */}
                        <li className="nav-item d-none d-md-block">
                            <TooltipItem placement="right" content={"Usuario"}>
                                <a href="javascript:;"className="nav-link" onClick={this.toggleUserblock}>
                                    <em className="icon-user"></em>
                                </a>
                            </TooltipItem>
                        </li>
                        { /* END User avatar toggle */}
                        { /* START lock screen */}
                        <li className="nav-item d-none d-md-block">
                            <TooltipItem placement="right" content={'Cerrar sesión'}>
                                <a href="javascript:void(0)" className="nav-link"
                                    onClick={()=>{
                                        swal({
                                            title: "Cerrar sesión",
                                            text: "¿Esta seguro(a) que desea salir de la plataforma?",
                                            buttons:{
                                                aceptar:{
                                                    text:"Si, salir",
                                                    value:"aceptar",
                                                    visible:!0,
                                                    //className:"btn btn-danger",
                                                    closeModal:true
                                                },
                                                cancel:{
                                                    text:"Cancelar",
                                                    value:false,
                                                    visible:!0,
                                                    //className:"btn btn-default",
                                                    closeModal:true
                                                }
                                            }
                                        }).then((value) => {
                                            if (value === "aceptar") {

                                              if ( sessionStorage.getItem('sUrlLogin') != '' ) {
                                                window.location = sessionStorage.getItem('sUrlLogin');
                                              }else {
                                                window.location = '/login';
                                              }
                                            }
                                        });
                                    }}
                                >
                                    <em className="icon-lock"></em>
                                </a>
                            </TooltipItem>
                        </li>
                        { /* END lock screen */}
                        { /* ENCUESTA FIJADA */}
                        <li className="nav-item text-white">
                            <TooltipItem placement="right" content={
                                (sessionStorage.getItem('sNombreEncuestaEmpresaFijada') != null) ? 'Encuesta fijada' : 'Sin encuesta fijada'
                            }>
                            <span className="nav-link">
                                <em className="icon-pin"></em>
                                {((sessionStorage.getItem('sNombreEncuestaEmpresaFijada') != null) ?
                                    <Link to={{
                                        pathname:'/aplicarencuesta',
                                        state: {
                                            sTipoVista:"editar", iIdEncuesta: sessionStorage.getItem('iIDEncuestaEmpresaFijada')
                                        }
                                    }} style={{
                                        color: "#ffffff"
                                    }}>
                                        {' Encuesta fijada: ' + sessionStorage.getItem('sNombreEncuestaEmpresaFijada')}
                                    </Link>

                                    : ' Sin encuesta fijada')}
                            </span>
                          </TooltipItem>
                        </li>
                        {/* ENCUESTA FIJADA END*/}
                    </ul>
                    { /* END Left navbar */}
                    { /* START Right Navbar */}
                    <ul className="navbar-nav flex-row">

                        { /* Fullscreen (only desktops) */}
                        <li className="nav-item d-none d-md-block">
                            <TooltipItem placement="right" content={"Pantalla completa"}>
                                <ToggleFullscreen className="nav-link"/>
                            </TooltipItem>
                        </li>
                        { /* START Alert menu */}
                        <UncontrolledDropdown nav inNavbar className="dropdown-list">
                                <TooltipItem placement="right" content={<span>Notificaciones</span>}>
                                <DropdownToggle nav className="dropdown-toggle-nocaret">
                                    <em className="icon-bell"></em>
                                    <span
                                        className="badge badge-danger">{this.state.aResultadoMostrarSolicitudes.aResult.filter((sol) => {
                                            return sol.Status === "Pendiente"
                                        }).length}</span>
                                </DropdownToggle>
                            </TooltipItem>
                            { /* START Dropdown menu */}
                            <DropdownMenu right className="dropdown-menu-right animated flipInX">
                                <DropdownItem>
                                    <Card className="m-0 p-0">
                                        <CardHeader className="border-bottom h4 text-center m-0 p-1">
                                            <CardTitle>Notificaciones</CardTitle>
                                        </CardHeader>
                                        { /* START list group */}
                                        <CardBody className="m-0 p-0">
                                            <Scrollable className="list-group" height="200">
                                                <ListGroup>

                                                    {((this.state.aResultadoMostrarSolicitudes.aResult.length > 0) ? '' :
                                                        <ListGroupItem className="text-center">Sin
                                                            incidencias</ListGroupItem>)}

                                                    {
                                                        this.state.aResultadoMostrarSolicitudes.aResult
                                                            .filter((sol) => {
                                                                return sol.Status === "Pendiente"
                                                            })
                                                            .map((aIncidencia, key) => (
                                                            key < 5 ?
                                                                <ListGroupItem key={key}>
                                                                    <Link className="media"
                                                                          to={{
                                                                              pathname: '/incidencias',
                                                                              state: aIncidencia
                                                                          }}>
                                                                        <div className="align-self-start mr-2">
                                                                            <em className={"fas fa-flag fa-2x " + ((aIncidencia.Status == 'Pendiente') ? 'text-warning' : 'text-success')}></em>
                                                                        </div>
                                                                        <div className="media-body">
                                                                            <p className="m-0">{(aIncidencia.Tipo != '') ? aIncidencia.Tipo : 'Incidencia'}</p>
                                                                            <p className="m-0 text-muted text-sm">{aIncidencia.DescripcionSolicitud}</p>
                                                                        </div>
                                                                    </Link>
                                                                </ListGroupItem>
                                                                :
                                                                ""
                                                        ))
                                                    }
                                                </ListGroup>
                                            </Scrollable>
                                        </CardBody>
                                        {
                                            (this.state.aResultadoMostrarSolicitudes.aResult.length > 5) ?
                                                <CardFooter>
                                                    <Link className="media"
                                                          to={{
                                                              pathname: '/incidencias',
                                                              state: {}
                                                          }}>
                                                        Ver más...
                                                    </Link>
                                                </CardFooter> :
                                                ""
                                        }
                                    </Card>
                                    { /* END list group */}

                                </DropdownItem>
                            </DropdownMenu>
                            { /* END Dropdown menu */}
                        </UncontrolledDropdown>
                        { /* END Alert menu */}
                        { /* START Offsidebar button */}
                        <li className="nav-item">
                            <span className="nav-link">
                                {/*  */}
                            </span>
                        </li>
                        { /* END Offsidebar menu */}
                    </ul>
                    { /* END Right Navbar */}


                </nav>
                { /* END Top Navbar */}
            </header>
        );
    }

}

Header.propTypes = {
    actions: PropTypes.object,
    settings: PropTypes.object
};

const mapStateToProps = state => ({settings: state.settings})
const mapDispatchToProps = dispatch => ({actions: bindActionCreators(actions, dispatch)})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);
